export const environment = {
  production: true,
  apiBaseUrl: 'https://revelbase-gshbg0emd0gpepcv.northeurope-01.azurewebsites.net/api/' // Updated API base URL
};
